import { IonList, IonSelect, IonSelectOption } from '@ionic/react';
import classNames from 'classnames';
import { FormErrors } from './FormErrors';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './FormFields.module.css';
interface SelectProps {
	placeholder?: string;
	name?: string;
	label?: string;
	onChange?: (e: any) => void;
	onBlur?: (e: any) => void;
	errors?: string[];
	color?: string;
	disabled?: boolean;
	width?: string;
	gap?: number;
	value?: string | string[] | number;
	id?: string;
	multiple?: boolean;
	options: {
		[key: string]: string;
	};
	className?: string;
	testId?: string;
}

export const Select: React.FC<SelectProps> = ({
	placeholder,
	name,
	value,
	label,
	onChange,
	multiple,
	disabled,
	errors,
	options,
	width,
	className,
	testId
}) => {
	const selectNames: string[] = Object.keys(options);

	return (
		<div className={classNames(className, styles.fieldHolder)} style={{ width: width || '100%' }}>
			{label && <div className={styles.label}>{label}</div>}
			<IonList>
				<IonSelect
					interface={multiple ? 'alert' : 'action-sheet'}
					placeholder={placeholder}
					multiple={multiple}
					disabled={disabled}
					className={styles.select}
					onIonChange={onChange}
					name={name}
					style={{ minWidth: width || '100%' }}
					value={value}
					data-testid={testId}
				>
					{options &&
						selectNames.map((name: string, i: number) => {
							return (
								<IonSelectOption data-testid={`${testId}-${options[name]}`} key={name + i} value={name}>
									{options[name]}
								</IonSelectOption>
							);
						})}
				</IonSelect>
			</IonList>
			<FormErrors errors={errors} />
		</div>
	);
};
